import { Button, Switch } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { DatePicker } from "zaman";
import { DropzoneDialog } from "material-ui-dropzone";
import * as Constants from "../../constants/urls";
import dateFormat from "dateformat";
import moment from "moment-jalaali";

const Tr = ({
    id,
    title,
    link,
    start,
    end,
    img_b,
    img_s,
    status,
    alert,
    alert_message,
    alert_type,
    checkEmptyEdit,
}) => {
    const [checked, setChecked] = useState(status ? true : false);
    const [cookies] = useCookies();
    const [edit, setEdit] = useState(false);
    const [titleEdit, setTitleEdit] = useState("");
    const [openBig, setOpenBig] = useState(false);
    const [openSmall, setOpenSmall] = useState(false);
    const [startDateEdit, setStartDateEdit] = useState("");
    const [endDateEdit, setEndDateEdit] = useState("");
    const [bigImgEdit, setBigImgEdit] = useState(null);
    const [smallImgEdit, setSmallImgEdit] = useState(null);
    const [linkEdit, setLinkEdit] = useState("");

    const handleStatusChange = (e) => {
        let status = e.target.checked;
        const url = Constants.apiUrl + `/api/edit_banner/status/${id}`;
        let data = {
            status,
        };
        axios
            .post(`${url}`, data, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    // window.location.href = "https://honari.com";

                    alert_message(response.data.message);
                    alert();
                    alert_type("alert-danger");
                    return false;
                } else if (response.status == 226) {
                    alert();
                    alert_type("alert-danger");
                    alert_message(response.data.message);
                } else {
                    alert();
                    alert_type("alert-success");
                    alert_message("وضعیت بنر مورد نظر با موفقیت تغییر یافت");
                    setChecked(status);
                }
            })
            .catch((error) => {
                alert();
                alert_type("alert-danger");
                alert_message("خطایی رخ داده است !");
                console.log(error);
                return false;
            });
    };

    const editHandler = () => {
        setEdit(true);
        setTitleEdit(title);
        setLinkEdit(link);
        setStartDateEdit(start);
        setEndDateEdit(end);
        setBigImgEdit(img_b);
        setSmallImgEdit(img_s);
    };

    const cancelHandler = () => {
        setEdit(false);
        setTitleEdit("");
        setLinkEdit("");
        setStartDateEdit("");
        setEndDateEdit("");
        setBigImgEdit(null);
        setSmallImgEdit(null);
    };

    const titleHandler = (e) => {
        setTitleEdit(e.target.value);
    };

    const linkHandler = (e) => {
        setLinkEdit(e.target.value);
    };

    const startDateHandler = ({ value }) => {
        let start = new Date(value);
        setStartDateEdit(dateFormat(start, "yyyy/mm/dd"));
    };

    const endDateHandler = ({ value }) => {
        let end = new Date(value);
        setEndDateEdit(dateFormat(end, "yyyy/mm/dd"));
    };

    const saveHandler = () => {
        const formData = new FormData();
        formData.append("title", titleEdit);
        formData.append("link", linkEdit);
        formData.append("startDate", startDateEdit);
        formData.append("endDate", endDateEdit);
        formData.append("image_b", bigImgEdit);
        formData.append("image_s", smallImgEdit);
        if (checkEmptyEdit(formData)) {
            alert_message(".لطفا هیچ فیلدی را خالی نگزارید");
            alert_type("alert-danger");
            alert();
            return;
        }

        const url = Constants.apiUrl + `/api/edit_banner/${id}`;
        axios
            .post(`${url}`, formData, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    // window.location.href = "https://honari.com";

                    alert_message(response.data.message);
                    alert();
                    alert_type("alert-danger");
                } else {
                    alert();
                    alert_type("alert-success");
                    alert_message("اطلاعات بنر با موفقیت ویرایش یافت");
                    setEdit(false);
                    window.location.reload();
                }
            })
            .catch((error) => {
                console.log(error);
                alert();
                alert_type("alert-danger");
                alert_message("خطایی رخ داده است !");
            });
    };

    return (
        <tr>
            <td>
                {edit ? (
                    <input
                        type="text"
                        className="form-control title_input"
                        value={titleEdit}
                        onChange={titleHandler}
                    />
                ) : (
                    <span>{title}</span>
                )}
            </td>
            <td>
                {edit ? (
                    <input
                        type="text"
                        className="form-control title_input"
                        value={linkEdit}
                        onChange={linkHandler}
                    />
                ) : (
                    <span>{link}</span>
                )}
            </td>
            <td>
                {edit ? (
                    <DatePicker
                        defaultValue={new Date(startDateEdit)}
                        round="x4"
                        onChange={(d) => startDateHandler(d)}
                    />
                ) : (
                    <span>
                        {moment(start, "YYYY:MM:DD").format("jYYYY/jMM/jDD")}
                    </span>
                )}
            </td>
            <td>
                {edit ? (
                    <DatePicker
                        defaultValue={new Date(endDateEdit)}
                        round="x4"
                        onChange={(d) => endDateHandler(d)}
                    />
                ) : (
                    <span>
                        {moment(end, "YYYY:MM:DD").format("jYYYY/jMM/jDD")}
                    </span>
                )}
            </td>
            <td>
                {edit ? (
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenBig(true)}
                        >
                            Add Image
                        </Button>

                        <DropzoneDialog
                            dialogTitle="آپلود عکس"
                            acceptedFiles={["image/*"]}
                            previewText=": پیش نمایش"
                            filesLimit={1}
                            initialFiles={[
                                `${Constants.ossUrl}/HeaderBanner/${img_b}`,
                            ]}
                            dropzoneText={
                                "Drag and drop an image here or click for big devices"
                            }
                            cancelButtonText={"انصراف"}
                            submitButtonText={"آپلود"}
                            open={openBig}
                            onDelete={(deleteFileObj) => {
                                setBigImgEdit(null);
                            }}
                            onClose={() => {
                                setOpenBig(false);
                                setBigImgEdit(null);
                            }}
                            onSave={(files) => {
                                setBigImgEdit(files[0]);
                                setOpenBig(false);
                            }}
                            showPreviews={true}
                            showFileNamesInPreview={false}
                        />
                    </div>
                ) : (
                    // <DropzoneArea
                    //     filesLimit={1}
                    // dropzoneText={
                    //     "Drag and drop an image here or click for big devices"
                    // }
                    //     de
                    //     // onChange={(files) => handleAddImage(files, "big")}
                    //     // getFileAddedMessage={handleAddedMessage}
                    //     // getFileRemovedMessage={handleRemovedMessage}
                    // />
                    <img
                        src={`${Constants.imagesBsaeUrl}/HeaderBanner/${img_b}`}
                        alt={title}
                        width="100"
                        height="100"
                    />
                )}
            </td>
            <td>
                {edit ? (
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenSmall(true)}
                        >
                            Add Image
                        </Button>

                        <DropzoneDialog
                            dialogTitle="آپلود عکس"
                            acceptedFiles={["image/*"]}
                            previewText=": پیش نمایش"
                            filesLimit={1}
                            initialFiles={[
                                `${Constants.ossUrl}/HeaderBanner/${img_s}`,
                            ]}
                            dropzoneText={
                                "Drag and drop an image here or click for small devices"
                            }
                            cancelButtonText={"انصراف"}
                            submitButtonText={"آپلود"}
                            open={openSmall}
                            onDelete={(deleteFileObj) => {
                                setSmallImgEdit(null);
                            }}
                            onClose={() => {
                                setOpenSmall(false);
                                setSmallImgEdit(null);
                            }}
                            onSave={(files) => {
                                setSmallImgEdit(files[0]);
                                setOpenSmall(false);
                            }}
                            showPreviews={true}
                            showFileNamesInPreview={false}
                        />
                    </div>
                ) : (
                    // <DropzoneArea
                    //     filesLimit={1}
                    // dropzoneText={
                    //     "Drag and drop an image here or click for big devices"
                    // }
                    //     de
                    //     // onChange={(files) => handleAddImage(files, "big")}
                    //     // getFileAddedMessage={handleAddedMessage}
                    //     // getFileRemovedMessage={handleRemovedMessage}
                    // />
                    <img
                        src={`${Constants.imagesBsaeUrl}/HeaderBanner/${img_s}`}
                        alt={title}
                        width="100"
                        height="100"
                    />
                )}
            </td>

            <td>
                <span>
                    <Switch onChange={handleStatusChange} checked={checked} />
                </span>
            </td>
            <th>
                <div className="btn-group">
                    {edit == false && (
                        <div
                            className="btn btn-warning rounded"
                            id={id}
                            onClick={editHandler}
                        >
                            ویرایش{" "}
                        </div>
                    )}
                    {edit == true && (
                        <div
                            className="btn btn-success m-2 rounded"
                            id={id}
                            onClick={saveHandler}
                        >
                            ذخیره{" "}
                        </div>
                    )}
                    {edit == true && (
                        <div
                            className="btn btn-danger m-2 rounded"
                            id={id}
                            onClick={cancelHandler}
                        >
                            انصراف{" "}
                        </div>
                    )}
                </div>
            </th>
        </tr>
    );
};
export default Tr;
